"use client"
import { colors } from "@/components/Providers/ThemeRegistry/theme"

import { Container, Grid, Stack, Typography, useMediaQuery, useTheme } from "@mui/material"
import Box from "@/components/Box"
import Head from "next/head"

import React from "react"

const AboutPage = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  return (
    <>
      <Head>
        <title>About</title>
      </Head>
      <Box
        width="100%"
        style={{
          alignItems: "center",
          justifyContent: "center",
          marginTop: "100px",
        }}
      >
        <Container
          maxWidth="xl"
          sx={{ pt: { xs: "48px", md: "64px" } }}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack maxWidth="1080px" gap="48px" alignItems="center" justifyContent="center">
            <Typography variant="h1" textAlign="center">
              About Ondo Foundation
            </Typography>

            <Typography
              variant={isMobile ? "h5" : "h4"}
              textAlign="center"
              fontWeight={600}
              color={colors.base.greyMid}
            >
              Ondo Foundation is a Cayman Islands Foundation Company whose{" "}
              <strong style={{ color: colors.base.black }}>
                mission is to usher in a new era of financial inclusivity and market efficiency through onchain
                institutional-grade financial products and services.
              </strong>{" "}
              Ondo Foundation is a nonprofit with no beneficial owners.{" "}
              <strong style={{ color: colors.base.black }}>
                Our mandate is specifically focused on several key areas:
              </strong>
            </Typography>
          </Stack>
          <AboutGrid />
        </Container>
      </Box>
    </>
  )
}

const AboutGrid = () => {
  return (
    <Grid container spacing={4} padding="16px" sx={{ maxWidth: { lg: 1300 }, margin: { xs: "48px 0", md: "160px 0" } }}>
      <GridItem
        title="Supporting Innovation"
        description="Financing and endorsing projects that responsibly advance the adoption of tokenized RWAs and their use in onchain financial protocols"
      />
      <GridItem
        title="Educating and Promoting Awareness"
        description="Increasing public understanding of our ecosystem and the benefits of asset tokenization"
      />
      <GridItem
        title="Treasury Management"
        description="Overseeing a treasury to facilitate strategic ecosystem growth"
      />
      <GridItem
        title="Contract Deployment"
        description="Issuing governance tokens and deploying protocol smart contracts"
      />
      <GridItem
        title="Web Application Management"
        description="Hosting web applications for certain platforms in the ecosystem"
      />
      <GridItem
        title="Strategic Partnerships and Engagement"
        description="Collaborating with businesses, regulators, and other stakeholders"
      />
      <GridItem title="Intellectual Property Management" description="Acquiring and handling IP rights" />
      <GridItem title="Community Events and Engagement" description="Organizing events to strengthen community ties" />
    </Grid>
  )
}

const GridItem: React.FC<{ title: string; description: string }> = ({ title, description }) => (
  <Grid item xs={12} md={4}>
    <Stack gap="8px">
      <Typography variant="h6" fontWeight={600}>
        {title}
      </Typography>
      <Typography variant="body1" color={colors.base.greyMid2}>
        {description}
      </Typography>
    </Stack>
  </Grid>
)
export default AboutPage
